//import _ from 'lodash';
import { connect } from 'react-redux';
import { search } from '../../modules/accounting/stationQuotedPrice';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	/** @namespace state.maps.dataDump */
	return {
		dataDumpMap : state.maps.dataDump,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchStationQuotedPrices : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
